module.exports = __webpack_public_path__ + "static/media/lock-feature-03.352fd0b3.png";